class AdvertInlineListController {
  constructor() {
    this.name = 'advertInlineList';
  }
}

export default AdvertInlineListController;
